// extracted by mini-css-extract-plugin
export var arrows = "_62-5";
export var decrementer = "_62-9";
export var disabled = "_62-3";
export var error = "_62-1";
export var hiddenText = "_62-a";
export var incrementer = "_62-8";
export var input = "_62-7";
export var inputWrapper = "_62-0";
export var readonly = "_62-2";
export var regular = "_62-6";
export var small = "_62-4";